import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  MapPinIcon,
  PhoneIcon,
  MailIcon,
  FacebookIcon,
  InstagramIcon,
  ArrowRightIcon,
  LinkedinIcon,
  MessageCircle,
  FileText,
  Download,

} from "lucide-react";
import { mockData } from "../data/mock";
import { openWhatsApp } from "../lib/utils";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";

const Footer = () => {
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);

  return (
    <footer className="bg-[#2563eb] text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 sm:gap-8">
          {/* Company Info */}
          <div className="space-y-4 sm:space-y-6 sm:col-span-2 lg:col-span-1">
            <div className="flex items-center space-x-2">
              <img className="h-6 w-6 sm:h-8 sm:w-8" src="/image/img_icon.png" alt="icon" />
              <h3 className="text-xl sm:text-2xl font-bold">TheLivCure</h3>
            </div>

            <p className="text-sm sm:text-base text-white leading-relaxed">
              India's leading surgical care platform providing advanced,
              minimally invasive treatments with personalized patient care
              and world-class medical expertise.
            </p>

            <div className="space-y-2 sm:space-y-3">
              <div className="flex items-center space-x-2 sm:space-x-3">
                <PhoneIcon className="w-4 h-4 sm:w-5 sm:h-5 text-orange-500 flex-shrink-0" />
                <button
                  type="button"
                  onClick={() => openWhatsApp("9311720045", "Hi, I am contacting you for treatment from TheLivCure site.")}
                  className="text-sm sm:text-base text-white underline underline-offset-4 hover:opacity-90"
                >
                  9311720045
                </button>
              </div>
              <div className="flex items-center space-x-2 sm:space-x-3">
                <PhoneIcon className="w-4 h-4 sm:w-5 sm:h-5 text-orange-500 flex-shrink-0" />
                <button
                  type="button"
                  onClick={() => openWhatsApp("9311720046", "Hi, I am contacting you for treatment from TheLivCure site.")}
                  className="text-sm sm:text-base text-white underline underline-offset-4 hover:opacity-90"
                >
                  9311720046
                </button>
              </div>
              <div className="flex items-center space-x-2 sm:space-x-3">
                <MailIcon className="w-4 h-4 sm:w-5 sm:h-5 text-orange-500 flex-shrink-0" />
                <span className="text-sm sm:text-base text-white break-all">tlc@thelivcure.com</span>
              </div>
              <div className="flex items-start space-x-2 sm:space-x-3">
                <MapPinIcon className="w-4 h-4 sm:w-5 sm:h-5 text-orange-500 mt-0.5 flex-shrink-0" />
                <span className="text-sm sm:text-base text-white">
                  Corporate Office: G-627, Sangam Vihar, New Delhi - 110062
                </span>
              </div>
            </div>
          </div>

          {/* Ophthalmology Services */}
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-4 sm:mb-6">Eye Care Services</h4>
            <ul className="space-y-2 sm:space-y-3">
              {mockData.specialties[0]?.treatments?.slice(0, 8).map((treatment) => {
                const treatmentUrl = treatment.toLowerCase().replace(/\s+/g, '-').replace(/[()]/g, '');
                return (
                  <li key={treatment}>
                    <Link
                      to={`/ophthalmology/${treatmentUrl}`}
                      className="text-sm sm:text-base text-white hover:text-white transition-colors duration-200 flex items-center group"
                    >
                      <ArrowRightIcon className="w-3 h-3 mr-2 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0" />
                      <span className="truncate">{treatment}</span>
                    </Link>
                  </li>
                );
              })}
              <li>
                <Link
                  to="/ophthalmology"
                  className="text-sm sm:text-base text-orange-400 hover:text-orange-300 transition-colors duration-200 flex items-center group font-medium"
                >
                  <ArrowRightIcon className="w-3 h-3 mr-2 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0" />
                  View All Eye Treatments
                </Link>
              </li>
            </ul>
          </div>

          {/* More Services */}
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-4 sm:mb-6">More Services</h4>
            <ul className="space-y-2 sm:space-y-3">
              {[
                { name: "Piles", path: "/piles" },
                { name: "Hernia", path: "/hernia" },
                { name: "Gall stones", path: "/gall-stone" },
                { name: "Kidney stone", path: "/kidney-stone" }
              ].map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.path}
                    className="text-sm sm:text-base text-white hover:text-white transition-colors duration-200 flex items-center group"
                  >
                    <ArrowRightIcon className="w-3 h-3 mr-2 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0" />
                    <span className="truncate">{item.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-4 sm:mb-6">Quick Links</h4>
            <ul className="space-y-2 sm:space-y-3">
              {[
                { name: "About Us", path: "/about" },
                { name: "Find Doctors", path: "/find-doctors" },
                { name: "Our Hospitals", path: "/hospitals" },
                // { name: "Patient Stories", path: "/patient-stories" },
                // { name: "Health Blog", path: "/blog" },
                { name: "Contact Us", path: "/contact" }
              ].map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm sm:text-base text-white hover:text-white transition-colors duration-200 flex items-center group"
                  >
                    <ArrowRightIcon className="w-3 h-3 mr-2 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Social */}
          <div className="space-y-4 sm:space-y-6 sm:col-span-2 lg:col-span-1">
            <div>
              <h4 className="text-base sm:text-lg font-semibold mb-4 sm:mb-6">Connect With Us</h4>
              <p className="text-sm sm:text-base text-white mb-4 sm:mb-6">
                Follow us for health tips and updates from our medical experts
              </p>

              <div className="flex space-x-3 sm:space-x-4">
                {[
                  { icon: FacebookIcon, color: "hover:text-blue-500", link: "https://www.facebook.com/share/1A8y4b1K86/?mibextid=wwXIfr" },
                  { icon: LinkedinIcon, color: "hover:text-sky-400", link: "http://linkedin.com/in/the-livcure-0a376a386" },
                  { icon: InstagramIcon, color: "hover:text-pink-500", link: "https://www.instagram.com/thelivcure?igsh=MXFhM25sNjV6eTdpdw==" },
                  { icon: MessageCircle, color: "hover:text-green-500", link: "http://wa.me/9311720045" }
                ].map(({ icon: Icon, color, link }, index) => (
                  <a
                    key={index}
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-8 h-8 sm:w-10 sm:h-10 bg-gray-800 rounded-full flex items-center justify-center text-white ${color} transition-all duration-200 hover:scale-110`}
                  >
                    <Icon className="w-4 h-4 sm:w-5 sm:h-5" />
                  </a>
                ))}
              </div>
            </div>

            {/* Emergency Contact */}
            <div className="bg-gradient-to-r from-orange-500/10 to-red-500/10 border border-gray-600-500/20 rounded-lg p-3 sm:p-4">
              <h5 className="text-sm sm:text-base text-orange-400 font-semibold mb-2">24/7 Emergency</h5>
              <div className="flex items-center space-x-2">
                <PhoneIcon className="w-3 h-3 sm:w-4 sm:h-4 text-orange-400 flex-shrink-0" />
                <button
                  type="button"
                  onClick={() => openWhatsApp("9311720045", "Hi, I am contacting you for treatment from  TheLivCure site.")}
                  className="text-sm sm:text-base text-white font-medium underline underline-offset-4 hover:opacity-90"
                >
                  9311720045
                </button>
              </div>
              <div className="flex items-center space-x-2 mt-2">
                <PhoneIcon className="w-3 h-3 sm:w-4 sm:h-4 text-orange-400 flex-shrink-0" />
                <button
                  type="button"
                  onClick={() => openWhatsApp("9311720046", "Hi, I am contacting you for treatment from  TheLivCure site.")}
                  className="text-sm sm:text-base text-white font-medium underline underline-offset-4 hover:opacity-90"
                >
                  9311720046
                </button>
              </div>
              <p className="text-xs text-white mt-1">
                Available round the clock for medical emergencies
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between space-y-3 sm:space-y-0">
            <div className="text-xs sm:text-sm text-white text-center sm:text-left">
              © 2025 TheLivCure. All rights reserved.
              <span className="text-orange-500 font-medium block sm:inline"> Your Trusted medical service provider TheLivCure</span>
            </div>

            <div className="flex flex-wrap justify-center sm:justify-end space-x-4 sm:space-x-6 text-xs sm:text-sm">
              <button
                onClick={() => setIsTermsModalOpen(true)}
                className="text-white hover:text-white transition-colors underline-offset-4 hover:underline"
              >
                Terms and Conditions
              </button>
              <Link to="#" className="text-white hover:text-white transition-colors">
             Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Terms and Conditions Modal */}
      <Dialog open={isTermsModalOpen} onOpenChange={setIsTermsModalOpen}>
        <DialogContent className="max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileText className="w-5 h-5" />
              Terms and Conditions
            </DialogTitle>
            <DialogDescription>
              Please review our terms and conditions
            </DialogDescription>
          </DialogHeader>
          
          <div className="flex-1 overflow-hidden">
            <div className="h-[60vh] w-full border rounded-lg overflow-hidden bg-gray-50">
              <iframe
                src="/files/terms & conditions.pdf"
                className="w-full h-full"
                title="Terms and Conditions"
                type="application/pdf"
              />
            </div>
          </div>

          <div className="flex items-center justify-between pt-4 border-t">
            <p className="text-sm text-muted-foreground">
              Having trouble viewing the document?
            </p>
            <a
              href="/files/terms & conditions.pdf"
              download
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
            >
              <Download className="w-4 h-4" />
              Download PDF
            </a>
          </div>
        </DialogContent>
      </Dialog>
    </footer>
  );
};

export default Footer;